/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { Row, Col, Button, Card } from "antd";
import { useHistory } from "react-router-dom";
import Layout from "../../layout/Landing";
import "./index.css";

export default function Index() {
  const history = useHistory();
  return (
    <Layout useButton={true}>
      <section id="page1">
        <img
          src={process.env.PUBLIC_URL + "/asset/decoration_1.png"}
          id="decor_1"
        />
        <Row justify="space-around" align="middle">
          <Col span={8} className="content">
            <h2>
              Mari bergabung dengan para psikolog tersertifikasi lain di
              Carenting!
            </h2>
            <p>
              Apabila Anda seorang psikolog dan ingin bergabung bersama kami
              sebagai tenaga ahli, silahkan klik tombol di bawah ini
            </p>
            <Button
              className="button_primary"
              onClick={() => {
                history.push("/register");
              }}
            >
              Register to be Psychologist
            </Button>
          </Col>
          <Col>
            <img
              src={process.env.PUBLIC_URL + "/asset/phone.png"}
              alt="Carenting Screenshot"
            />
          </Col>
        </Row>
      </section>
      <section
        id="page2"
        // style={{ backgroundImage: process.env.PUBLIC_URL + "/asset/bg2.png" }}
      >
        <div>
          <img
            src={process.env.PUBLIC_URL + "/asset/decoration_4.png"}
            id="decor_4"
          />
        </div>
        <div style={{ textAlign: "center", marginBottom: 80 }}>
          <span className="header">
            Apa saja fitur utama di Aplikasi Carenting?
          </span>
          <p className="content">
            Anda bisa berkonsultasi dengan psikolog terkait parenting dengan
            beberapa metode, antar lain
          </p>
        </div>
        <Row justify="space-around">
          <Col span={5}>
            <Card style={{ padding: 16 }}>
              <img
                className="icon"
                src={process.env.PUBLIC_URL + "/asset/icon_chat.png"}
                alt="Chat"
              />
              <div className="icon_info">Chat</div>
            </Card>
          </Col>
          <Col span={5}>
            <Card style={{ padding: 16 }}>
              <img
                className="icon"
                src={process.env.PUBLIC_URL + "/asset/icon_call.png"}
                alt="Chat"
              />
              <div className="icon_info">Call</div>
            </Card>
          </Col>
          <Col span={5}>
            <Card style={{ padding: 16 }}>
              <img
                className="icon"
                src={process.env.PUBLIC_URL + "/asset/icon_vidcall.png"}
                alt="Chat"
              />
              <div className="icon_info">Video Call</div>
            </Card>
          </Col>
        </Row>
        <img
          src={process.env.PUBLIC_URL + "/asset/decoration_3.png"}
          id="decor_3"
        />
      </section>
    </Layout>
  );
}
